import { registerPlugin } from '@capacitor/core';

export interface ScannedImage {
  base64: string;
  width: number;
  height: number;
}

export interface ScanResult {
  images: ScannedImage[];
  pageCount: number;
}

export interface AvailabilityResult {
  available: boolean;
}

export interface DocumentScannerPlugin {
  scanDocument(): Promise<ScanResult>;
  isAvailable(): Promise<AvailabilityResult>;
}

const DocumentScanner = registerPlugin<DocumentScannerPlugin>('DocumentScanner');

export default DocumentScanner;
